require('../../modules/es.typed-array.float64-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Float64Array;
